(ns teamoesterreich.util.log
  (:require [goog.array :as garray]))

(def TEST_MACHINE (= "true" (.-testMachine js/toe_config)))

(def original-log js/console.log)

(defn log "Log args directly to the browser console"
  [& args]
  (when (and TEST_MACHINE js/console original-log)
    (.apply original-log js/console (to-array args))))

(defn log-pr
  "Log pr-str of args to browser console"
  [& args]
  (apply log (map pr-str args)))

(def out js/console.info)
(def debug js/console.log)

(set! *print-newline* false)
(set-print-fn!
  (fn []
    (let [xs (js-arguments)]
      (apply log (garray/clone xs)))))
(set-print-err-fn!
  (fn []
    (let [xs (js-arguments)]
      (apply log (garray/clone xs)))))

(set! js/console.info (fn []))
(set! js/console.error (fn []))
(set! js/console.log (fn []))
(set! js/console.warn (fn []))
